<span>
  <button style="margin-left:5px;" *ngFor="let button of buttonConfig.Buttons"  [class]="getClass(button)" (click)="buttonClicked(button)">{{button.Label}}</button>
</span>

